module.exports = __webpack_public_path__ + "img/ctrl-t-dagger-stub-1.8ed52199.svg";